import script from "./CRM10_007INS_shy.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM10_007INS_shy.vue?vue&type=script&setup=true&lang=js"

import "./CRM10_007INS_shy.vue?vue&type=style&index=0&id=e8bc436c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8bc436c"]])

export default __exports__